
export interface SleepOptions {
    /**
     * STRONGLY CONSIDER calling periodicTasks.sleep() instead.
     *
     * Skips the warning in setTimeout() when timeout values passed are too large
     * (because the long timeout has been vetted).
     */
    bypassWatchdog?: boolean;
}

const BYPASS_KEY = '__tyt_bypassTimeoutWatchdog';
export function sleep(time: number = 0, options?: SleepOptions): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        let previousBypass = globalThis[BYPASS_KEY];
        try {
            if (options?.bypassWatchdog === true)
                globalThis[BYPASS_KEY] = true;
            setTimeout(() => resolve(), time);
        } finally {
            globalThis[BYPASS_KEY] = previousBypass;
        }
    });
}